import { api } from '@/api'
import Button from '@/components/Button'
import ErrorAllText from '@/components/ErrorText/AllErros'
import Input from '@/components/Input'
import Spinner from '@/components/Spinner/Spinner'
import Title from '@/components/Title'
import { setPasswordSchema } from '@/utils/schemesFormik'
import { GxForm } from '@garpix/garpix-web-components-react'
import { useFormik } from 'formik'
import React from 'react'
import style from '../styles/change_password.module.scss'

const ChangePassword = (): React.ReactElement => {
  const formik = useFormik({
    validationSchema: setPasswordSchema,
    initialValues: {
      old_password: '',
      password: '',
      confirm_password: '',
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors, setStatus }) {
      api
        .setPassword({
          old_password: values.old_password,
          new_password: values.password
        })
        .then(() => {
          setStatus('success')
          setSubmitting(false)
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm
  return (
    <div className={style.change}>
      <Title type='h2' theme='h3' className={style.change__title}>
        Изменить пароль
      </Title>
      {formik.status === 'success'
        ? (
          <div>Пароль успешно изменен</div>
          )
        : (
          <GxForm onGx-submit={onSubmit}>
            <Input
              name='old_password'
              value={formik.values.old_password}
              onGx-input={formik.handleChange}
              error={formik.errors.old_password}
              label='Старый пароль:'
              type='password'
              required
              className={style.change__input}
            />
            <Input
              name='password'
              value={formik.values.password}
              onGx-input={formik.handleChange}
              error={formik.errors.password}
              label='Новый пароль:'
              type='password'
              placeholder='Минимум 8 символов'
              required
              className={style.change__input}
            />
            <Input
              name='confirm_password'
              value={formik.values.confirm_password}
              onGx-input={formik.handleChange}
              error={formik.errors.confirm_password}
              label='Повтори новый пароль:'
              type='password'
              required
              className={style.change__input}
            />
            {formik.errors.apiError !== ''
              ? (
                <div>
                  <ErrorAllText text={formik.errors.apiError} />
                </div>
                )
              : null}
            <Button
              disabled={formik.isSubmitting}
              size='large'
              wide
              highlight
              type='submit'
            >
              {formik.isSubmitting ? <Spinner slot='icon-left' /> : 'Изменить'}
            </Button>
          </GxForm>
          )}
    </div>
  )
}

export default ChangePassword
